import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AiAssistantService } from 'src/app/service/ai-assistant-service/ai-assistant.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-ai-assistant-conversation-modal',
  templateUrl: './ai-assistant-conversation-modal.component.html',
  styleUrls: ['./ai-assistant-conversation-modal.component.css']
})
export class AiAssistantConversationModalComponent implements OnInit {

  @Input() tripObj:any
  @Output() onClose = new EventEmitter<void>();
  @Output() onConfirm = new EventEmitter<any>();

  Conversation = [];
  conversationDate: string = null;
  isLoading = false;
  error: string = null;
  memberData:any;
  chatLogs:any
  loadingRecordings: Set<number> = new Set();
  activeSessionIndex: number | null = null;

  constructor(
    private aiAssistantService: AiAssistantService) { }

  ngOnInit() {
    if (this.tripObj) {
      this.memberData = this.tripObj.member;
      this.fetchChatLogs();
    }
  }

  fetchChatLogs() {
    this.isLoading = true;
    this.aiAssistantService.getTripChatLogs(this.tripObj._id).subscribe(res => {
      if (res && res.error) {
        this.Conversation = [];
        this.isLoading = false;
        return;
      }
      const data = (res && res.data) ? res.data : res;
      this.chatLogs = data;
      this.Conversation = (data && data.Conversation && data.Conversation.length) ? data.Conversation : [];
      this.conversationDate = data ? data.createdAt : null;
      this.activeSessionIndex = null;
      this.isLoading = false;
    }, _err => {
      this.Conversation = [];
      this.isLoading = false;
    });
  }

  confirm() {
  this.onConfirm.emit(this.tripObj);
  this.closeModal();
}

  closeModal() {
    this.onClose.emit();
  }

  getRecording(session: any, index: number) {
    if (session.signedRecordingUrl || this.loadingRecordings.has(index)) return;
    if (!session.recordingUrl) return;

    if (this.activeSessionIndex !== null && this.activeSessionIndex !== index) {
      const prev = this.Conversation[this.activeSessionIndex];
      if (prev) { prev.signedRecordingUrl = null; }
    }

    this.loadingRecordings.add(index);
    const payload = { url: session.recordingUrl };
    this.aiAssistantService.getRecording(payload).subscribe((data: any) => {
      this.loadingRecordings.delete(index);
      if (data) {
        session.signedRecordingUrl = data;
        this.activeSessionIndex = index;
      }
    }, () => {
      this.loadingRecordings.delete(index);
    });
  }
}
